/**
 * Centralized Pro-Dashboard fetchers.
 *
 * Every new endpoint introduced by the Pro Dashboard upgrade is reached
 * through this file. Inside each fetcher, a single MOCK_PRO branch
 * decides whether to return mock data (Phase 1) or hit the real backend
 * (Phase 2 onwards). This keeps the `if (MOCK_PRO)` decision in exactly
 * one place per endpoint, per the orchestration brief.
 *
 * Each fetcher resolves to an axios-shaped { data } object so callers
 * use a uniform interface regardless of which branch fired.
 */

import axios from "axios";
import { API } from "@/App";
import {
  MOCK_PRO,
  mockStats,
  mockTrend,
  mockActivity,
  mockHealth,
  mockAsync,
} from "./mock-pro";

// Extended /api/stats payload: original counts + deltas + sparkline series.
export const fetchStatsPro = async (userId) => {
  if (MOCK_PRO) return mockAsync(mockStats);
  return axios.get(`${API}/stats?user_id=${userId}`);
};

// 7-day booking-status trend (new in Phase 2).
export const fetchTrend = async (userId, days = 7) => {
  if (MOCK_PRO) return mockAsync(mockTrend);
  return axios.get(`${API}/stats/trend?user_id=${userId}&days=${days}`);
};

// Recent activity event feed (new in Phase 2).
export const fetchActivity = async (userId, limit = 20) => {
  if (MOCK_PRO) return mockAsync(mockActivity);
  return axios.get(`${API}/activity?user_id=${userId}&limit=${limit}`);
};

// Composed service health snapshot (new in Phase 2).
// Auth via user_id query param — backend uses Depends(get_authenticated_user_id)
// which requires it. Callers must pass user.id.
export const fetchHealthAll = async (userId) => {
  if (MOCK_PRO) return mockAsync(mockHealth);
  return axios.get(`${API}/health/all?user_id=${userId}`);
};
